export default __webpack_public_path__ + "static/media/fixture1_student.99e12481.png";